import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(1 63 114)', // Customize this color as needed
    },
  },
});

export default theme;